var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quill-editor"},[_c('quill-editor',{ref:"QuillEditor",attrs:{"content":_vm.content,"options":_vm.editorOption},on:{"input":function (val) { return _vm.$emit('update:content', val); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }